(() => {
  const section = document.querySelector('[data-fvpd-version="gl-lash-0817f9"]');
  const root = section?.querySelector('.lash-page');
  document.body.classList.add('glormate-lash-active');
  if (!root) return;

  const track = root.querySelector('.gallery-track');
  const slides = [...root.querySelectorAll('.gallery-slide')];
  const dotsWrap = root.querySelector('.gallery-dots');
  const currentEl = root.querySelector('.gallery-current');
  const autoButton = root.querySelector('.gallery-auto');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let activeIndex = 0;
  let autoTimer = null;
  let manualPause = false;
  let galleryVisible = true;
  let scrollSyncTimer = null;

  const updateGalleryState = (index) => {
    activeIndex = Math.max(0, Math.min(slides.length - 1, index));
    slides.forEach((slide, i) => slide.classList.toggle('is-current', i === activeIndex));
    [...dotsWrap.children].forEach((dot, i) => {
      dot.classList.toggle('is-selected', i === activeIndex);
      dot.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');
    });
    currentEl.textContent = String(activeIndex + 1);
  };

  const goToSlide = (index, behavior = 'smooth') => {
    const next = (index + slides.length) % slides.length;
    track.scrollTo({ left: next * track.clientWidth, behavior });
    updateGalleryState(next);
  };

  const stopAuto = () => {
    if (autoTimer) window.clearInterval(autoTimer);
    autoTimer = null;
  };

  const startAuto = () => {
    stopAuto();
    if (manualPause || reduceMotion.matches || document.hidden || !galleryVisible) return;
    autoTimer = window.setInterval(() => goToSlide(activeIndex + 1), 2500);
  };

  const pauseForManualControl = () => {
    manualPause = true;
    autoButton.textContent = 'AUTO · PLAY';
    autoButton.setAttribute('aria-label', 'Play automatic gallery');
    stopAuto();
  };

  slides.forEach((slide, index) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.setAttribute('aria-label', `Show product image ${index + 1}`);
    dot.addEventListener('click', () => {
      pauseForManualControl();
      goToSlide(index);
    });
    dotsWrap.append(dot);
  });
  updateGalleryState(0);

  root.querySelector('.gallery-prev').addEventListener('click', () => {
    pauseForManualControl();
    goToSlide(activeIndex - 1);
  });
  root.querySelector('.gallery-next').addEventListener('click', () => {
    pauseForManualControl();
    goToSlide(activeIndex + 1);
  });
  autoButton.addEventListener('click', () => {
    manualPause = !manualPause;
    autoButton.textContent = manualPause ? 'AUTO · PLAY' : 'AUTO · PAUSE';
    autoButton.setAttribute('aria-label', manualPause ? 'Play automatic gallery' : 'Pause automatic gallery');
    if (manualPause) stopAuto(); else startAuto();
  });
  track.addEventListener('pointerdown', pauseForManualControl, { passive: true });
  track.addEventListener('touchstart', pauseForManualControl, { passive: true });
  track.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    pauseForManualControl();
    goToSlide(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
  });
  track.addEventListener('scroll', () => {
    window.clearTimeout(scrollSyncTimer);
    scrollSyncTimer = window.setTimeout(() => {
      const index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      updateGalleryState(index);
    }, 80);
  }, { passive: true });
  document.addEventListener('visibilitychange', startAuto);
  reduceMotion.addEventListener?.('change', startAuto);

  const galleryObserver = new IntersectionObserver(([entry]) => {
    galleryVisible = entry.isIntersecting;
    startAuto();
  }, { threshold: 0.25 });
  galleryObserver.observe(track);
  startAuto();

  const offerCards = [...root.querySelectorAll('.offer-card')];
  const compareNode = root.querySelector('[data-compare]');
  const selectionNode = root.querySelector('[data-selection-label]');
  const ctaPrice = root.querySelector('[data-cta-price]');
  const ctaLabel = root.querySelector('[data-cta-label]');
  const purchaseLink = root.querySelector('[data-purchase-link]');
  const stickySelection = document.querySelector('[data-sticky-selection]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const stickyAction = document.querySelector('[data-sticky-action]');
  const stickyLink = document.querySelector('[data-sticky-link]');
  const closingSelection = document.querySelector('[data-closing-selection]');
  const closingLink = document.querySelector('[data-closing-link]');
  const form = section.querySelector('#glormateFairyProductForm');
  const nativeQuantity = form?.querySelector('[data-native-quantity]');
  const currency = section.dataset.currency || 'USD';
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(Number(cents) / 100);

  const selectOffer = (card, shouldScroll = false) => {
    if (!card) return;
    offerCards.forEach((item) => {
      const selected = item === card;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-checked', selected ? 'true' : 'false');
    });

    const priceCents = Number(card.dataset.priceCents);
    const compareCents = Number(card.dataset.compareCents || 0);
    const label = card.dataset.display;
    const quantity = card.dataset.quantity;
    const kitWord = quantity === '1' ? 'KIT' : 'KITS';
    if (nativeQuantity) nativeQuantity.value = quantity;
    root.querySelector('[data-price]').textContent = money(priceCents);
    compareNode.textContent = compareCents ? money(compareCents) : '';
    compareNode.hidden = !compareCents;
    selectionNode.textContent = label;
    ctaLabel.textContent = `GET ${quantity} ${kitWord}`;
    ctaPrice.textContent = money(priceCents);
    stickySelection.textContent = label;
    stickyAction.textContent = `GET ${quantity}`;
    stickyPrice.textContent = money(priceCents);
    closingSelection.textContent = label.toUpperCase();
    if (shouldScroll) root.querySelector('.selector').scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
  };

  offerCards.forEach((card) => card.addEventListener('click', () => selectOffer(card)));
  root.querySelectorAll('[data-select-quantity]').forEach((look) => {
    look.addEventListener('click', () => {
      const card = offerCards.find((item) => item.dataset.quantity === look.dataset.selectQuantity);
      selectOffer(card, true);
    });
  });

  stickyLink?.addEventListener('click', () => form?.requestSubmit());
  closingLink?.addEventListener('click', () => form?.requestSubmit());

  const video = root.querySelector('.application-video');
  const videoToggle = root.querySelector('.video-toggle');
  const setVideoButton = () => {
    videoToggle.textContent = video.paused ? '▶' : 'Ⅱ';
    videoToggle.setAttribute('aria-label', video.paused ? 'Play application video' : 'Pause application video');
  };
  videoToggle.addEventListener('click', async () => {
    if (video.paused) {
      try { await video.play(); } catch (_) {}
    } else video.pause();
    setVideoButton();
  });
  video.addEventListener('play', setVideoButton);
  video.addEventListener('pause', setVideoButton);
  const videoObserver = new IntersectionObserver(async ([entry]) => {
    if (entry.isIntersecting && !reduceMotion.matches) {
      try { await video.play(); } catch (_) {}
    } else video.pause();
    setVideoButton();
  }, { threshold: 0.45 });
  videoObserver.observe(video);

  const sticky = document.querySelector('.sticky-buy');
  const hero = root.querySelector('.hero');
  const closing = root.querySelector('.closing-section');
  let heroVisible = true;
  let closingVisible = false;
  const syncSticky = () => sticky.classList.toggle('is-visible', !heroVisible && !closingVisible);
  new IntersectionObserver(([entry]) => { heroVisible = entry.isIntersecting; syncSticky(); }, { threshold: 0.05 }).observe(hero);
  new IntersectionObserver(([entry]) => { closingVisible = entry.isIntersecting; syncSticky(); }, { threshold: 0.1 }).observe(closing);
})();
